import { defineComponent, Teleport } from 'vue'

import TeleportContent from '@/components/common/teleport/TeleportContent'

export default defineComponent(() => {
  return () => (
    <Teleport to='body'>
      <TeleportContent
        t-data='v-loading'
        class='fixed inset-0 z-9999 size-full'
      >
        <div class='absolute size-full cursor-wait bg-black opacity-0' />
      </TeleportContent>
    </Teleport>
  )
}, {
  name: 'VLoading'
})
